import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-5xl font-serif font-bold text-[#1a1a1a] mb-8 text-center">
            À propos de Giletau
          </h1>

          <div className="prose prose-lg max-w-none">
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl mb-12 border border-gray-100">
              <p className="text-xl text-gray-700 leading-relaxed mb-0">
                Giletau est une plateforme indépendante de documentation et d'analyse des mouvements citoyens, des mobilisations sociales et des enjeux démocratiques contemporains.
              </p>
            </div>

            <h2 className="text-3xl font-serif font-bold text-[#1a1a1a] mt-12 mb-6">
              Qui sommes-nous ?
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Giletau est né de la volonté de créer un espace d'information rigoureux et accessible sur les mouvements sociaux qui transforment notre société. Face à la multiplication des mobilisations citoyennes et à la complexité croissante des enjeux démocratiques, nous avons créé cette plateforme pour documenter, analyser et expliquer ces phénomènes avec rigueur et indépendance.
            </p>

            <h2 className="text-3xl font-serif font-bold text-[#1a1a1a] mt-12 mb-6">
              Pour qui ?
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Giletau s'adresse à tous les citoyens qui souhaitent comprendre les dynamiques sociales et démocratiques de notre époque :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-3 mb-6">
              <li>Les citoyens engagés qui veulent approfondir leur compréhension des mouvements sociaux</li>
              <li>Les étudiants et chercheurs en sciences sociales et politiques</li>
              <li>Les journalistes et observateurs de la vie démocratique</li>
              <li>Les acteurs associatifs et militants qui cherchent des analyses documentées</li>
              <li>Toute personne curieuse des évolutions sociétales contemporaines</li>
            </ul>

            <h2 className="text-3xl font-serif font-bold text-[#1a1a1a] mt-12 mb-6">
              Notre approche
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Nous documentons et analysons les mouvements citoyens avec une approche rigoureuse et pluraliste. Notre travail s'appuie sur :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-3 mb-6">
              <li>La vérification systématique des sources et des faits</li>
              <li>La contextualisation historique et sociologique des mobilisations</li>
              <li>L'écoute des différents acteurs et points de vue</li>
              <li>L'analyse des enjeux démocratiques et institutionnels</li>
              <li>La mise en perspective des évolutions sociétales</li>
            </ul>

            <div className="bg-[#1a1a1a] text-white p-8 rounded-2xl mt-12">
              <h3 className="text-2xl font-bold mb-4">
                Notre engagement
              </h3>
              <p className="text-gray-200 leading-relaxed mb-0">
                Giletau est une plateforme indépendante, sans affiliation politique ou économique. Notre seul engagement est de fournir une information rigoureuse, documentée et accessible sur les mouvements citoyens et les enjeux démocratiques qui façonnent notre société.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default About;
